import Decimal from 'decimal.js';

/**
 * Shared zero for Decimal reduces/comparisons — avoids re-allocating `new Decimal(0)` per call.
 *
 * Frozen so it cannot be tampered with: decimal.js instances are immutable by API (every
 * operation returns a NEW Decimal, so there is no need to copy this before use), but the
 * internal digit/sign/exponent fields are plain properties — `Object.freeze` makes any
 * direct write to them throw a TypeError instead of silently corrupting every consumer's zero.
 */
export const DECIMAL_ZERO: Decimal = Object.freeze(new Decimal('0.00'));

/**
 * Null-safe Decimal construction, mirroring the backend's `Decimal(str(value))`: decimal.js
 * parses a number by its shortest round-trip decimal representation, the same digits
 * Python's str() produces. `null`/`undefined`/`NaN` coalesce to 0 (the backend raises
 * instead — callers there never hold optional money).
 */
export const safeDecimal = (value: number | undefined | null): Decimal => new Decimal(String(value || 0));
